//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('acReportLayouts', {
//        templateUrl: 'views/components/views/acReportLayouts/acReportLayouts.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'accountingPlService', function (stateService, accountingPlService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListReportLayouts: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadAcReportLayouts() {
//                vm.model.itemsListReportLayouts = await accountingPlService.listAcReportLayouts({ res: 'a' });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'acreportlayout':
//                        go({ acreportlayout_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadAcReportLayouts();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
